import React from 'react';
import OfferItem from './offer-item';

//https://reactjs.org/docs/lists-and-keys.html
class OffersList extends React.Component {

	constructor() {
		super();
	}
	
	render() {
		return (
		<ul className="offers__list grid--offers">
	      {this.props.data.map((item,) =>
	          <OfferItem 
					key={item.ID} 
					title={item.post_title} 
					desc={item.custom_meta_fields.desc}
					type={item.custom_meta_fields.type}
					value={item.custom_meta_fields.value}
					url={item.custom_meta_fields.url} 
	          		/>
			)}
			<li className="offer__item item--image">
				<div>
					<figure className="offer__cover cover">
						<img laoding="lazy" src={`${wp_core.theme_url}/assets/img/offers-cover.jpg`} />
					</figure>
				</div>
			</li>
		</ul>
		);
	}
}	

export default OffersList;